import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	notificationColumnHeaderPrefix: {
		defaultMessage: 'Notifications for',
		id: 'personal-settings-notifications-config-table.common.accordion.notification-column-header-prefix',
		description:
			'Will be displayed before the project avatar and title, e.g "Notifications for <proj avatar> IT Operations"',
	},
});
